import { notificationApi } from './api';
import { isRunningAsPwa } from './pwaRuntime';

const MAX_BADGE_COUNT = 99;

export const isAppBadgeSupported = (): boolean =>
  typeof navigator !== 'undefined' && 'setAppBadge' in navigator && isRunningAsPwa();

const canShowAppBadge = (): boolean =>
  isAppBadgeSupported() && 'Notification' in window && Notification.permission === 'granted';

export const syncAppBadge = async (unreadCount: number): Promise<void> => {
  if (!canShowAppBadge()) {
    return;
  }

  try {
    if (unreadCount > 0) {
      const badgeCount = Math.min(Math.floor(unreadCount), MAX_BADGE_COUNT);
      await navigator.setAppBadge(badgeCount);
      return;
    }

    if ('clearAppBadge' in navigator) {
      await navigator.clearAppBadge();
    }
  } catch {
    // Keep badge sync best-effort; never block app flow.
  }
};

export const clearAppBadge = async (): Promise<void> => {
  if (!isAppBadgeSupported() || !('clearAppBadge' in navigator)) {
    return;
  }

  try {
    await navigator.clearAppBadge();
  } catch {
    // Keep badge clear best-effort.
  }
};

export const syncAppBadgeFromServer = async (): Promise<void> => {
  try {
    const response = await notificationApi.unreadCount();
    if (response.success && response.data) {
      await syncAppBadge(response.data.count);
    }
  } catch {
    // Ignore badge sync failures.
  }
};
